export const localString = "es-ES";

export const decimalFormatOptions = {
	minimumFractionDigits: 0,
	maximumFractionDigits: 2,
};

export const QUANTITY_DECIMALS = 2;
